import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  pageTitle: {
    id: "funding-application: accounts page title",
    defaultMessage: "Add all your bank accounts",
  },
  pageSubtitle: {
    id: "funding-application: accounts page subtitle",
    defaultMessage:
      "Include current accounts, credit cards, and any overdraft or credit line. Any accounts you don't provide now will be requested later, which will delay your application.",
  },
  addAccountInstantly: {
    id: "funding-application: add account instantly button",
    defaultMessage: "Add connection instantly",
  },
  addStatementsManually: {
    id: "funding-application: add statements manually button",
    defaultMessage: "Add statements manually",
  },
  uploadStatementsPanelTitle: {
    id: "funding-application: accounts page upload statements panel title",
    defaultMessage: "Upload statements",
  },
  connectedBadge: {
    id: "funding-application: accounts page connected badge",
    defaultMessage: "Connected",
  },
  readyBadge: {
    id: "funding-application: accounts page ready badge",
    defaultMessage: "Ready",
  },
  viewAccountAction: {
    id: "funding-application: accounts page view account action",
    defaultMessage: "View",
  },
  bankAccountsSectionTitle: {
    id: "funding-application: accounts page bank accounts section title",
    defaultMessage: "Bank accounts",
  },
  connectedWithProvider: {
    id: "funding-application: accounts page connected with provider subtitle",
    defaultMessage: "Connected with {provider} ({currency})",
  },
  connectedWithProviderNoCurrency: {
    id: "funding-application: accounts page connected with provider no currency subtitle",
    defaultMessage: "Connected with {provider}",
  },
  businessAccountFallback: {
    id: "funding-application: accounts page business account fallback label",
    defaultMessage: "Business account",
  },
  requiredFromYouHeading: {
    id: "funding-application: accounts page required from you heading",
    defaultMessage: "Required from you",
  },
  requiredFromYouBodyText: {
    id: "funding-application: accounts page required from you body text",
    defaultMessage:
      "We need continuous, up-to-date banking data from {startDate} onwards for each account linked to your business. If you're uploading statements, they must be PDF or CSV files under 50MB. {viewMore}",
  },
  viewMore: {
    id: "funding-application: accounts page view more link",
    defaultMessage: "View more.",
  },
  requirementsModalTitle: {
    id: "funding-application: accounts page requirements modal title",
    defaultMessage: "Required from you",
  },
  requirementsModalBody: {
    id: "funding-application: accounts page requirements modal body",
    defaultMessage:
      "We need at least {requiredMonths} months of continuous banking data for every account associated with your business.",
  },
  requirementsModalListHeading: {
    id: "funding-application: accounts page requirements modal list heading",
    defaultMessage: "We'll ask for more information if the data has:",
  },
  requirementsModalRuleGaps: {
    id: "funding-application: accounts page requirements modal rule gaps",
    defaultMessage: "gaps longer than 14 days",
  },
  requirementsModalRuleNoTransactions: {
    id: "funding-application: accounts page requirements modal rule no transactions",
    defaultMessage: "no transactions within the last 14 days",
  },
  requirementsModalFootnote: {
    id: "funding-application: accounts page requirements modal footnote",
    defaultMessage:
      "If your business had a genuine quiet period, the account is new, or it was recently closed, you'll get a chance to explain this later.",
  },
  connectModalTitle: {
    id: "funding-application: accounts page connect modal title",
    defaultMessage: "Connect your bank",
  },
  connectModalBody: {
    id: "funding-application: accounts page connect modal body",
    defaultMessage: "Select your bank's country. We'll use this to connect your account securely.",
  },
  connectModalContinue: {
    id: "funding-application: accounts page connect modal continue",
    defaultMessage: "Continue",
  },
  bankLocationLabel: {
    id: "funding-application: accounts page bank location label",
    defaultMessage: "Bank location",
  },
  doneUploadingAction: {
    id: "funding-application: accounts page done uploading action",
    defaultMessage: "Done",
  },
  accountDetailsTypeAndCurrency: {
    id: "funding-application: accounts page account details type and currency",
    defaultMessage: "{accountType} account ({currency})",
  },
  accountDetailsType: {
    id: "funding-application: accounts page account details type",
    defaultMessage: "{accountType} account",
  },
  accountDetailsBodyText: {
    id: "funding-application: accounts page account details body text",
    defaultMessage: "Your account is connected. We'll process this data as part of your application.",
  },
});
